import { render, staticRenderFns } from "./YoutubeAddProfileDialog.vue?vue&type=template&id=47e18e42&scoped=true"
import script from "./YoutubeAddProfileDialog.vue?vue&type=script&lang=js"
export * from "./YoutubeAddProfileDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e18e42",
  null
  
)

export default component.exports